export interface PostHogConfig {
  apiHost: string;
  uiHost: string;
  key: string;
  useReverseProxy: boolean;
  fallbackToDirect: boolean;
}

export const getPostHogConfig = (): PostHogConfig => {
  // const isClient = typeof window !== 'undefined';

  // if (!isClient) {
  //   return {
  //     apiHost: '',
  //     uiHost: '',
  //     key: '',
  //     useReverseProxy: false,
  //     fallbackToDirect: false,
  //   };
  // }

  const env = (window as any).ENV;
  const posthogKey = env?.POSTHOG_KEY || '';
  const originalHost = env?.POSTHOG_HOST || '';
  const normalizedApiHost = originalHost.startsWith('http') ? originalHost : `https://${originalHost}`;
  const uiHost = normalizedApiHost.replace('i.posthog.com', 'posthog.com');

  console.log('[PostHog Config] ===== PostHog Configuration =====');
  console.log('[PostHog Config] Proxy disabled: using direct connection');
  console.log('[PostHog Config] apiHost:', normalizedApiHost);
  console.log('[PostHog Config] uiHost:', uiHost);
  console.log('[PostHog Config] posthogKey:', posthogKey ? 'Set' : 'Missing');
  console.log('[PostHog Config] originalHost:', originalHost);
  console.log('[PostHog Config] =====================================');

  return {
    apiHost: normalizedApiHost,
    uiHost,
    key: posthogKey,
    useReverseProxy: false,
    fallbackToDirect: false,
  };
};

export const getPostHogInitConfig = () => {
  const config = getPostHogConfig();

  return {
    api_host: config.apiHost,
    ui_host: config.uiHost,
    loaded: (posthog: any) => {
      // Enable debug mode in development
      if (process.env.NODE_ENV === 'development') {
        posthog.debug();
      }
    },
    // Additional configuration options
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    enable_recording_console_log: process.env.NODE_ENV === 'development',
    enable_recording_network_payloads: false,
    respect_dnt: true, // Respect Do Not Track
  };
};

// Function to get fallback configuration when proxy fails

export const getPostHogFallbackConfig = () => {
  const env = (window as any).ENV;
  const posthogKey = env?.POSTHOG_KEY || '';
  const originalHost = env?.POSTHOG_HOST || '';
  const normalizedApiHost = originalHost.startsWith('http') ? originalHost : `https://${originalHost}`;

  return {
    api_host: normalizedApiHost,
    ui_host: normalizedApiHost.replace('i.posthog.com', 'posthog.com'),
    loaded: (posthog: any) => {
      if (process.env.NODE_ENV === 'development') {
        posthog.debug();
      }

      console.log('[PostHog] Fallback to direct connection activated');
    },
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    enable_recording_console_log: process.env.NODE_ENV === 'development',
    enable_recording_network_payloads: false,
    respect_dnt: true,
  };
};
